import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SharedModule } from '@src/app/shared/shared.module';

/** Resultado de uma consulta cadastral, no semáforo do cartão. */
export type DealRegistryCheckTone = 'ok' | 'pending' | 'alert';

/** Uma consulta do resumo cadastral (protestos, SCR, negativações, mídia negativa...). */
export interface DealRegistryCheck {
  /** Nome da consulta, como aparece no cartão ("Protestos", "SCR (Bacen)"). */
  label: string;
  /** O que a consulta disse ("Nada consta", "em andamento", o motivo da falha). */
  result: string;
  tone: DealRegistryCheckTone;
}

/**
 * Resumo cadastral do deal (card 3380, task 3383): o que as consultas cadastrais (VAAS) disseram sobre a
 * empresa, só o que importa para a decisão.
 *
 * ⚠️ **Ainda não existe consulta à VAAS no backend.** Ela vem no card #3075 (Gates e VAAS depois da
 * documentação). Decisão de 08/10/2026 (Victor, na página de perguntas do card 3380): deixar o bloco pronto e
 * escondido até existir dado. Quando o endpoint existir, o `DealDetailComponent` preenche `registrySummary`.
 */
export interface DealRegistrySummary {
  /** Situação geral das consultas ("Em consulta", "Concluído"). */
  status: string;
  checks: DealRegistryCheck[];
  /** "Leitura do motor": a conclusão em uma frase, com os pontos de atenção. */
  engineReading: string | null;
}

/**
 * Cartão "Resumo cadastral · Cognito" na coluna lateral da Visão geral (card 3380, task 3383).
 *
 * - Só o time interno: quem decide é o pai (`visaoInterna`). O conteúdo nunca é exposto ao parceiro.
 * - **Sem dado, não aparece**: nem cartão vazio, nem "pendente". Hoje o pai sempre passa `null` (ver acima).
 */
@Component({
  selector: 'app-deal-registry-summary',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './deal-registry-summary.component.html',
  styleUrl: './deal-registry-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealRegistrySummaryComponent {
  readonly summary = input<DealRegistrySummary | null>(null);

  /** O cartão só existe com pelo menos uma consulta. */
  protected readonly visible = computed(() => (this.summary()?.checks?.length ?? 0) > 0);
}
